import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, Badge } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import CityState from "../../constants/CityState.json";
import CountryCode from "../../constants/CountryCode.json";
import jwt_decode from "jwt-decode";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaUsers, FaTimes } from "react-icons/fa";

const LeadEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectUser, setSelectUser] = useState([]);
  const [state, setState] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]); // For multi-select
  const [leadStatusArray, setleadStatusArray] = useState(
    JSON.parse(sessionStorage.getItem("lead_status")),
  );
  const [emailError, setEmailError] = useState("");
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const [userInfoo, setUserInfoo] = useState(
    jwt_decode(sessionStorage.getItem("token")),
  );

  const hasTagsModule =
    userInfoo?.modules?.some((module) => module.url === "tags") || false;

  const leadSource = [
    { value: "Web", label: "Web" },
    { value: "Phone Enquiry", label: "Phone Enquiry" },
    { value: "Partner Referral", label: "Partner Referral" },
    { value: "Purchased List", label: "Purchased List" },
    { value: "Other", label: "Other" },
  ];
  const leadStatus = leadStatusArray;

  const [selectedState, setSelectedState] = useState("");
  const [lead, setLead] = useState(() => {
    const initialState = location.state || {};
    let initialCountryCode = initialState.country_code || "+91";
    if (initialCountryCode && !initialCountryCode.startsWith("+")) {
      initialCountryCode = `+${initialCountryCode}`;
    }
    return {
      id: initialState.id || "",
      firstname: initialState.firstname || "",
      lastname: initialState.lastname || "",
      country_code: initialCountryCode,
      whatsapp_number: initialState.whatsapp_number || "",
      email: initialState.email || "",
      title: initialState.title || "",
      dob: initialState.dob || "",
      tag_names: initialState.tag_names || [],
      leadsource: initialState.leadsource || "",
      state: initialState.state || "",
      city: initialState.city || "",
      leadstatus: initialState.leadstatus || "Open - Not Contacted",
      ownername: initialState.ownername || "",
      ownerid: initialState.ownerid || "",
      ownerids: initialState.ownerids || [],
      address: initialState.address || "",
      description: initialState.description || "",
      all_owner_names: initialState.all_owner_names || [],
    };
  });

  const [tagOptions, setTagOptions] = useState([]);
  let userInfo;
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    let userInfo = jwt_decode(sessionStorage.getItem("token"));

    async function init() {
      try {
        // Fetch users for dropdown
        const fetchUser = await WhatsAppAPI.fetchUsers();
        let usr = fetchUser.map((item) => ({
          value: item.id,
          label: item.username,
          ...item,
        }));
        setSelectUser(usr);

        // Handle lead data and selected users
        if (location?.state) {
          let whatsappNumber = location.state.whatsapp_number;
          setLead((prev) => ({ ...prev, whatsapp_number: whatsappNumber }));

          // Handle tag_names
          if (location.state.tag_names) {
            let parsedTags = [];
            if (typeof location.state.tag_names === "string") {
              try {
                parsedTags = JSON.parse(location.state.tag_names);
              } catch (e) {
                parsedTags = [];
              }
            } else if (Array.isArray(location.state.tag_names)) {
              parsedTags = location.state.tag_names;
            }

            setLead((prev) => ({
              ...prev,
              tag_names: parsedTags,
            }));
          }

          // Handle ownerids and selectedUsers
          if (location.state.ownerids && location.state.ownerids.length > 0) {
            // Convert ownerids to selectedUsers format
            const ownerIds = location.state.ownerids;
            const selectedUsersList = usr.filter((user) =>
              ownerIds.includes(user.value),
            );
            setSelectedUsers(selectedUsersList);

            // Also set single ownerid (first one) for backward compatibility
            if (ownerIds.length > 0) {
              const primaryOwner = selectedUsersList[0];
              setLead((prev) => ({
                ...prev,
                ownerid: primaryOwner.value,
                ownername: primaryOwner.label,
              }));
            }
          } else if (location.state.ownerid) {
            // Backward compatibility: single owner
            const singleOwner = usr.find(
              (user) => user.value === location.state.ownerid,
            );
            if (singleOwner) {
              setSelectedUsers([singleOwner]);
              setLead((prev) => ({
                ...prev,
                ownerids: [singleOwner.value],
                ownername: singleOwner.label,
              }));
            }
          }

          // Handle all_owner_names if available
          if (location.state.all_owner_names) {
            setLead((prev) => ({
              ...prev,
              all_owner_names: location.state.all_owner_names,
            }));
          }
        } else {
          // New lead: set current user as default
          const currentUser = usr.find((user) => user.value === userInfo.id);
          if (currentUser) {
            setSelectedUsers([currentUser]);
            setLead((prev) => ({
              ...prev,
              ownerid: userInfo.id,
              ownername: userInfo.username,
              ownerids: [userInfo.id],
            }));
          }
        }

        // Setup states
        let st = [];
        CityState.map((item) => {
          var obj = {};
          obj.value = item.state;
          obj.label = item.state;
          st.push(obj);
        });
        let finalStates = {};
        st = st.filter(function (currentObject) {
          if (currentObject.value in finalStates) {
            return false;
          } else {
            finalStates[currentObject.value] = true;
            return true;
          }
        });
        if (lead.state) {
          setSelectedState(lead.state);
        }
        setState(st);

        // Fetch tags
        const tags = await WhatsAppAPI.getTags(true);
        if (tags.success) {
          const formattedTags = tags?.records.map((tag) => ({
            value: tag.id,
            label: tag.name,
          }));
          setTagOptions(formattedTags);
        } else {
          setTagOptions([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Error loading data");
      }
    }

    init();
  }, []);

  useEffect(() => {
    if (selectedState) {
      const cities = CityState.filter(
        (item) => item.state === selectedState,
      ).map((item) => ({ value: item.name, label: item.name }));
      setCities(cities);
    }
  }, [selectedState]);

  const handleState = (e) => {
    let filteredCities = [];
    CityState.forEach(function (obj) {
      if (obj.state === e.value) {
        filteredCities.push({
          label: obj.name,
          value: obj.name,
        });
      }
    });
    setCities(filteredCities);
    setLead({ ...lead, state: e.value });
  };

  const handleTextOnlyChange = (e) => {
    const value = e.target.value.replace(/[^A-Za-z ]/g, "");
    setLead({ ...lead, [e.target.name]: value });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      if (value) {
        if (!emailRegex.test(value)) {
          setEmailError("Please enter a valid email address");
        } else {
          setEmailError("");
        }
      } else {
        setEmailError("");
      }
    }

    setLead({ ...lead, [e.target.name]: e.target.value });
  };

  // Handle multiple users selection
  const handleUsersChange = (selectedOptions) => {
    setSelectedUsers(selectedOptions || []);

    // Update ownerids array
    const ownerIds = selectedOptions.map((option) => option.value);
    const ownerNames = selectedOptions.map((option) => option.label);

    // Update lead with ownerids and set first owner as primary
    const updatedLead = {
      ...lead,
      ownerids: ownerIds,
      ownerid: ownerIds.length > 0 ? ownerIds[0] : "",
      ownername: ownerNames.length > 0 ? ownerNames[0] : "",
    };

    setLead(updatedLead);
  };

  // Remove a specific user from selection
  const removeUser = (userId) => {
    const newSelectedUsers = selectedUsers.filter(
      (user) => user.value !== userId,
    );
    handleUsersChange(newSelectedUsers);
  };

  // Fixed handleTagChange to store array of objects with id and name
  const handleTagChange = (selectedOptions) => {
    const selectedTags = selectedOptions
      ? selectedOptions.map((option) => ({
        id: option.value,
        name: option.label,
      }))
      : [];
    setLead({
      ...lead,
      tag_names: selectedTags,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedUsers.length === 0) {
      toast.error("Please select at least one owner");
      return;
    }

    let result = {};
    lead.blocked = false;

    // Prepare data to send
    const dataToSend = {
      ...lead,
      // Make sure we send ownerids array
      ownerids: lead.ownerids || [],
      // For backward compatibility, also send ownerid (first in array)
      ownerid:
        lead.ownerids && lead.ownerids.length > 0 ? lead.ownerids[0] : "",
      tag_names: Array.isArray(lead.tag_names) ? lead.tag_names : [],
      business_number: sessionStorage.getItem("selectedWhatsAppSetting") || "",
    };

    // console.log("Data being sent:", dataToSend);

    try {
      if (lead.id) {
        result = await WhatsAppAPI.updateLead(dataToSend);

        if (result.errors) {
          toast.error(`${result.errors}`);
        } else {
          toast.success("Record updated successfully");
          navigate(`/leads/${lead.id}`, { state: result.records });
        }
      } else {
        result = await WhatsAppAPI.createLead(dataToSend);

        if (result.errors) {
          toast.error(`${result.errors}`);
        } else {
          toast.success("Record saved successfully");
          navigate(`/leads/${result?.records?.id}`, { state: result.records });
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while saving the lead");
    }
  };

  const isFormValid =
    Boolean(lead.firstname?.trim()) &&
    Boolean(lead.lastname?.trim()) &&
    Boolean(lead.whatsapp_number?.trim()) &&
    Boolean(lead.leadstatus?.trim()) &&
    selectedUsers.length > 0;

  const handleCancel = () => {
    navigate("/leads/", { state: lead });
  };

  // Custom styles for react-select to prevent closing on select
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#0d6efd" : "#dee2e6",
      "&:hover": {
        borderColor: "#0d6efd",
      },
      boxShadow: state.isFocused
        ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)"
        : "none",
      minHeight: "38px",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999, // Ensure dropdown stays on top
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#e9ecef",
      borderRadius: "4px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      fontWeight: "500",
    }),
    multiValueRemove: (base) => ({
      ...base,
      "&:hover": {
        backgroundColor: "#dc3545",
        color: "white",
      },
    }),
  };

  return (
    <>
      <Container className="mt-5">
        <Row className="g-0 mx-5 text-center">
          <Col lg={12} xs={12} sm={12}>
            <div
              className="text-center p-2"
              style={{
                height: "40px",
                backgroundColor: "#ffffff",
                borderRadius: "5px",
              }}
            >
              <span
                className="fw-semibold p-1"
                style={{ color: "#605C68", fontSize: "large" }}
              >
                {lead.id ? "Edit Lead" : "Add Lead"}
              </span>
            </div>
          </Col>
        </Row>
      </Container>
      <Container className="mt-1 mb-5">
        <Row className="mx-5 g-0">
          <Col lg={12} sm={12} xs={12} className="mb-2">
            <Card className="h-100" style={{ border: "none" }}>
              <Card.Body>
                <Row className="mb-3">
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="ms-3">
                      <Form.Label className="form-view-label">
                        First Name
                      </Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        type="text"
                        name="firstname"
                        required={true}
                        placeholder="Enter First Name"
                        value={lead.firstname || ""}
                        onChange={handleTextOnlyChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please provide First Name.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="ms-3 me-3">
                      <Form.Label className="form-view-label">
                        Last Name
                      </Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        required={true}
                        type="text"
                        name="lastname"
                        placeholder="Enter LastName"
                        value={lead.lastname || ""}
                        onChange={handleTextOnlyChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col lg={2} sm={2} xs={2}>
                    <Form.Group className="ms-3">
                      <Form.Label className="form-view-label">
                        Country Code
                      </Form.Label>
                      <Form.Select
                        name="country_code"
                        value={lead.country_code || "+91"}
                        onChange={handleChange}
                        style={{ height: "36px" }}
                      >
                        {CountryCode.map((country, index) => (
                          <option key={index} value={country.country_code}>
                            {country.country} ({country.country_code})
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={4} sm={8} xs={8}>
                    <Form.Group className="">
                      <Form.Label className="form-view-label">
                        WhatsApp Number
                      </Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        type="text"
                        name="whatsapp_number"
                        required
                        placeholder="Enter WhatsApp number"
                        value={lead.whatsapp_number || ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">Email</Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        type="email"
                        name="email"
                        placeholder="Enter Email"
                        value={lead.email || ""}
                        onChange={handleChange}
                        isInvalid={emailError !== ""}
                      />
                      <Form.Control.Feedback type="invalid">
                        {emailError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="ms-3">
                      <Form.Label className="form-view-label">
                        Date of Birth
                      </Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        type="date"
                        name="dob"
                        max={today}
                        value={lead.dob ? lead.dob.split("T")[0] : ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  {hasTagsModule && (
                    <Col lg={6} sm={12} xs={12}>
                      <Form.Group className="mx-3">
                        <Form.Label className="form-view-label">
                          Tags
                        </Form.Label>
                        <Select
                          isMulti
                          name="tags"
                          options={tagOptions}
                          value={tagOptions.filter((option) =>
                            lead.tag_names?.some(
                              (tag) =>
                                (typeof tag === "object" ? tag.id : tag) ===
                                option.value,
                            ),
                          )}
                          onChange={handleTagChange}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Select tags..."
                        />
                      </Form.Group>
                    </Col>
                  )}
                </Row>
                <Row className="mb-3">
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="ms-3">
                      <Form.Label className="form-view-label">
                        Source
                      </Form.Label>
                      <Form.Select
                        style={{ height: "36px" }}
                        aria-label="Enter status"
                        value={lead.leadsource || ""}
                        name="leadsource"
                        onChange={handleChange}
                      >
                        <option value="">--Select Source--</option>
                        <option value="Phone">Phone</option>
                        <option value="Partner Referral">
                          Partner Referral
                        </option>
                        <option value="BNI">BNI</option>
                        <option value="Purchased List">Purchased List</option>
                        <option value="Web">Web</option>
                        <option value="Email">Email</option>
                        <option value="Whatsapp">Whatsapp</option>
                        <option value="Ad Leads">Ad Leads</option>
                        <option value="Salesforce">Salesforce</option>
                        <option value="Zoho">Zoho</option>
                        <option value="Other">Other</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="ms-3">
                      <Form.Label className="form-view-label">
                        Title
                      </Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        type="text"
                        name="title"
                        placeholder="Enter Title"
                        value={lead.title || ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>


                <Row className="mb-3">
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="ms-3">
                      <Form.Label className="form-view-label">
                        Status
                      </Form.Label>
                      <Form.Select
                        required
                        aria-label="Enter Status"
                        name="leadstatus"
                        style={{ height: "36px" }}
                        onChange={handleChange}
                        value={lead.leadstatus}
                      >
                        <option value="">--Select Status--</option>
                        {leadStatusArray.map((item, index) => (
                          <option value={item.label} key={index}>
                            {item.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Address
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        name="address"
                        placeholder="Enter Address"
                        value={lead.address || ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={12} sm={12} xs={12}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        <FaUsers className="me-2" />
                        Assigned Users ({selectedUsers.length}){" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Select
                        isMulti
                        value={selectedUsers}
                        onChange={handleUsersChange}
                        options={selectUser}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select users..."
                        styles={customSelectStyles}
                        closeMenuOnSelect={false} // Don't close dropdown on select
                        hideSelectedOptions={false} // Show selected options in dropdown
                        isSearchable
                        noOptionsMessage={() => "No users found"}
                      />
                      <Form.Text className="text-muted">
                        Select multiple users to assign this lead to
                      </Form.Text>
                      {/* Display selected users as badges */}
                      {selectedUsers.length > 0 && (
                        <div className="mt-2 d-flex flex-wrap gap-2">
                          {selectedUsers.map((user, index) => (
                            <Badge
                              key={user.value}
                              className="badge-assign px-3 py-2 d-flex align-items-center"
                            >
                              {user.label}
                              {index === 0 && (
                                <span className="ms-2 small">(Primary)</span>
                              )}
                              <FaTimes
                                className="ms-2"
                                style={{ cursor: "pointer" }}
                                onClick={() => removeUser(user.value)}
                                title="Remove user"
                              />
                            </Badge>
                          ))}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col lg={12} sm={12} xs={12}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Description
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="description"
                        placeholder="Enter Description"
                        value={lead.description || ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-2">
                  <Col lg={12} sm={12} xs={12} className="mt-4">
                    <hr></hr>
                  </Col>
                </Row>

                <Row className="g-0 mb-2">
                  <Col lg={12} sm={12} xs={12} className="text-end mt-2">
                    <Button
                      className="mx-2"
                      variant="light"
                      onClick={handleCancel}
                    >
                      Back
                    </Button>
                    <Button
                      variant="secondary"
                      disabled={!isFormValid}
                      onClick={handleSubmit}
                      type="button"
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer autoClose={30000} />
    </>
  );
};

export default LeadEdit;
